import React from "react";
import MemberProfilePropertyComponent from "./MemberProfilePropertyComponent";
import FetchHelper from "./lib/fetchHelper.js";
// Never hidden from the other volunteers, so there is nothing to switch: the property stays in the data
// and the editor does not draw it.
const NOT_EDITED = ["showMobilePhone"];
export class MemberProfilePropertyEditorComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            dirty: false,
            valid: true,
            saving: false
        };
        this.postable = {};
        this.onPropertyDirty = this.onPropertyDirty.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.save = this.save.bind(this);
        this.onRefreshClick = this.onRefreshClick.bind(this);
        this.refreshCalendar = this.refreshCalendar.bind(this);
    }
    componentDidMount() {
        FetchHelper.get(`/bpapi/memberprofile/properties`)
            .then((result) => {
            this.setState({ isLoaded: true, properties: result });
        });
    }
    onPropertyDirty(propertyAlias, value, dirty) {
        this.postable[propertyAlias] = { value: value, dirty: dirty };
        let post = Object.entries(this.postable);
        let elements = Object.entries(document.getElementById('member-profile-form').elements);
        this.setState({ dirty: post.reduce((agg, cur) => agg || cur[1].dirty, false), valid: elements.reduce((agg, cur) => agg && cur[1].validity.valid, true), success: undefined, error: undefined });
    }
    save() {
        // Save only dirty and valid values
        let p = Object
            .entries(this.postable)
            .filter((x) => x[1].dirty)
            .map((x) => { return { alias: x[0], value: x[1].value }; });
        if (p.length > 0) {
            FetchHelper.post(`/bpapi/memberprofile/properties`, p)
                .then((result) => {
                this.postable = {};
                this.setState({ saving: false, properties: result, dirty: false, valid: true, success: "Dine oplysninger er gemt." });
            })
                .catch((e) => {
                console.error(e);
                this.setState({ saving: false, error: "Kunne ikke gemme dine oplysninger" });
            });
        }
        else {
            this.setState({ saving: false });
        }
    }
    onSaveClick() {
        if (this.state.valid) {
            this.setState({ saving: true, success: undefined, error: undefined }, () => this.save());
        }
    }
    refreshCalendar() {
        fetch(`/bpapi/membercalendar/refresh`, {})
            .then((result) => {
            this.setState({ saving: false });
        });
    }
    onRefreshClick() {
        this.setState({ saving: true }, () => this.refreshCalendar());
    }
    render() {
        if (this.state.isLoaded) {
            let saveDisabled = {
                disabled: (!this.state.saving && (this.state.dirty && this.state.valid)) ? undefined : true
            };
            let refreshDisabled = {
                disabled: (!this.state.saving) ? undefined : true
            };
            var calIdProp = this.state.properties.find(prop => prop.alias === "calendarId");
            return (React.createElement("div", { className: "bi-card bi-pf-card" },
                React.createElement("h2", null, "Mine oplysninger"),
                React.createElement("form", { id: "member-profile-form", className: "bi-pf-form", noValidate: true, onSubmit: (e) => e.preventDefault() }, this.state.properties
                    .filter((property) => !NOT_EDITED.includes(property.alias))
                    .map((property) => {
                    return (React.createElement(MemberProfilePropertyComponent, { key: `property-${property.alias}`, property: property, onDirty: this.onPropertyDirty }));
                })),
                !!this.state.error && React.createElement("div", { className: "bi-bv-alert bi-bv-alert-error", role: "alert" }, this.state.error),
                !!this.state.success && React.createElement("div", { className: "bi-bv-alert bi-bv-alert-ok", role: "status" }, this.state.success),
                React.createElement("div", { className: "bi-pf-actions" },
                    React.createElement("button", Object.assign({ type: "button", className: "bi-btn bi-btn-save", onClick: () => this.onSaveClick() }, saveDisabled), (this.state.saving) ? React.createElement("i", { className: "fas fa-cog fa-spin" }) : React.createElement("span", null, "Gem")),
                    (calIdProp && calIdProp.value && calIdProp !== '')
                        ? React.createElement("button", Object.assign({ type: "button", className: "bi-btn bi-btn-outline", onClick: () => this.onRefreshClick() }, refreshDisabled),
                            React.createElement("span", null, "Opfrisk kalender"))
                        : React.createElement(React.Fragment, null))));
        }
        return (React.createElement("div", { className: "bi-card bi-pf-card" },
            React.createElement("p", { className: "bi-pf-hint" }, "Indl\u00E6ser...")));
    }
}
